import {
  CalendarCheck,
  ClipboardCheck,
  CloudSun,
  Compass,
  Crosshair,
  Download,
  Eye,
  Gauge,
  Gift,
  Layers,
  Library,
  ListOrdered,
  Map,
  MessageSquare,
  Plane,
  PlaneLanding,
  PlaneTakeoff,
  Radio,
  RotateCcw,
  Route,
  ShieldAlert,
  Split,
  TrendingUp,
  Waypoints,
  Wind,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, navy card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Complete Volumes', icon: Library, featured: true },
  { label: '150 Ready-to-Teach Flight Lessons', icon: CalendarCheck, featured: true },
  { label: '100% Visual', icon: Eye, featured: true },
  { label: 'Beginner to Checkride-Ready', icon: TrendingUp, featured: true },
  { label: 'Cockpit Familiarization', icon: Gauge },
  { label: 'Aircraft Control', icon: Plane },
  { label: 'Aerodynamics', icon: Wind },
  { label: 'Core Flight Maneuvers', icon: Route },
  { label: 'Takeoffs', icon: PlaneTakeoff },
  { label: 'Traffic Patterns', icon: Waypoints },
  { label: 'Approaches', icon: Crosshair },
  { label: 'Landings', icon: PlaneLanding },
  { label: 'Go-Arounds', icon: RotateCcw },
  { label: 'Navigation', icon: Compass },
  { label: 'Radio Communication', icon: Radio },
  { label: 'Flight Planning', icon: Map },
  { label: 'Weather Awareness', icon: CloudSun },
  { label: 'Risk Management', icon: ShieldAlert },
  { label: 'Decision-Making', icon: Split },
  { label: 'Visual Flight Sequences', icon: Layers },
  { label: 'Instructor Cues', icon: MessageSquare },
  { label: 'Common Errors & Corrections', icon: Wrench },
  { label: 'Student Assessments', icon: ClipboardCheck },
  { label: 'Training Progressions', icon: ListOrdered },
  { label: '5 Professional Bonus Guides', icon: Gift },
  { label: 'Immediate Digital Access', icon: Download },
]
